module.exports = __webpack_public_path__ + "static/media/cms_right_arrow.ab45ac35.svg";